let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gAUB6")).then(() => parcelRequire('83lE1'));